interface NamedMember {
  name_first?: string | null
  name_last?: string | null
}

const compareText = (a?: string | null, b?: string | null): number =>
  (a ?? '').localeCompare(b ?? '', undefined, { sensitivity: 'base' })

/**
 * Roster members in the Team screen's default order: last name, then first
 * name, ignoring case. Returns a new array — the roster context's lists are
 * shared state and must not be sorted in place.
 */
export const sortByLastName = <T extends NamedMember>(members: T[]): T[] =>
  [...members].sort(
    (a, b) =>
      compareText(a.name_last, b.name_last) ||
      compareText(a.name_first, b.name_first)
  )
